module.exports = __webpack_public_path__ + "static/media/standardBank.1a6a775b.png";